module.exports = __webpack_public_path__ + "img/teaser_pferd8.f1a7d2f2.jpg";